// extracted by mini-css-extract-plugin
export var button = "events-module--button--56df8";
export var component = "events-module--component--12d0c";
export var container = "events-module--container--78daf";
export var event = "events-module--event--072d0";
export var eventDate = "events-module--eventDate--a27e1";
export var eventDay = "events-module--eventDay--a8981";
export var eventDesc = "events-module--eventDesc--b8e43";
export var eventDetail = "events-module--eventDetail--cf88c";
export var eventTime = "events-module--eventTime--e9476";
export var gun_awareness = "events-module--gun_awareness--26782";
export var july4 = "events-module--july4--3206c";
export var juneteenth = "events-module--juneteenth--9e07d";
export var mental_health = "events-module--mental_health--fba9d";
export var title = "events-module--title--e3a96";